__turbopack_context__.v({
  "countryButton": "styles-module-scss-module__F58j0a__countryButton",
  "countryName": "styles-module-scss-module__F58j0a__countryName",
  "countrySection": "styles-module-scss-module__F58j0a__countrySection",
  "filterControls": "styles-module-scss-module__F58j0a__filterControls",
  "introText": "styles-module-scss-module__F58j0a__introText",
  "mantineInput": "styles-module-scss-module__F58j0a__mantineInput",
  "noResults": "styles-module-scss-module__F58j0a__noResults",
  "plusIcon": "styles-module-scss-module__F58j0a__plusIcon",
  "proxiesGrid": "styles-module-scss-module__F58j0a__proxiesGrid",
  "proxiesList": "styles-module-scss-module__F58j0a__proxiesList",
  "proxyCard": "styles-module-scss-module__F58j0a__proxyCard",
  "proxyCount": "styles-module-scss-module__F58j0a__proxyCount",
  "proxyDescription": "styles-module-scss-module__F58j0a__proxyDescription",
  "proxyItems": "styles-module-scss-module__F58j0a__proxyItems",
  "proxyLink": "styles-module-scss-module__F58j0a__proxyLink",
  "proxyName": "styles-module-scss-module__F58j0a__proxyName",
  "recommendedBadge": "styles-module-scss-module__F58j0a__recommendedBadge",
  "regionHeader": "styles-module-scss-module__F58j0a__regionHeader",
  "regionSection": "styles-module-scss-module__F58j0a__regionSection",
  "searchInput": "styles-module-scss-module__F58j0a__searchInput",
  "selectInput": "styles-module-scss-module__F58j0a__selectInput",
});
